module.exports = __webpack_public_path__ + "static/img/block-bg1.976947d4.png";